module.exports = __webpack_public_path__ + "img/news2.39e5153c.png";